<ng-container
  *ngLet="{
    _user: userState.user$ | async,
    _order: orderState.order$ | async,
    _screen: settingsService.screenBreakpoint$ | async,
    _burger: themeState.burger$ | async,
    _city: orderState.currentCity$ | async,
    _showChangeLocation: navPanelState.showChangeLocation$ | async
  } as obj"
  [ngVar]="false"
  #overlay="ngVar"
>
  <h4
    *ngIf="(isWizardPage || isFlatPage) && obj._city && obj._showChangeLocation"
    class="subtitle-primary-medium-14"
    [class.--crsr-pntr]="isWizardPage"
    (click)="isWizardPage && changeLocation()"
  >
    {{ obj._city.title }}
  </h4>

  <div
    *ngIf="obj._user && !isLoginPage"
    class="--flex --jc-center --align-center h-40-px"
    style="border-radius: 50%; overflow: hidden"
    (click)="obj._user.anonymous ? toLogin() : openProfileMenu()"
    #accountIcon
  >
    <div *ngIf="obj._user.anonymous" class="--flex --crsr-pntr">
      <app-svg
        type="stroke"
        [subType]="colorState === 'light' ? 'main' : 'inverse'"
        src="assets/img/user-auth.svg"
      ></app-svg>

      <span
        class="subtitle-primary-medium-14"
        [class.app-text-color-static]="colorState === 'dark'"
        >Войти</span
      >
    </div>

    <app-svg *ngIf="!obj._user.anonymous" [src]="obj._burger" type="none"></app-svg>
  </div>
</ng-container>
